import { DissectedError, DissectedErrorGroups, LogType, logError } from '../../..'
import { ApiResponse } from '../../../types/Response'
import { DissectParserProps } from '../types/DissectParserTypes'

export const parseResponseOk = async <TApiResponse extends ApiResponse>({
    responseStatusText,
    responseStatus,
    responseOk,
    caller,
}: DissectParserProps<TApiResponse>): Promise<void> => {
    if (!responseOk) {
        logError(responseStatusText, {
            caller,
            logType: LogType.STATUS_TEXT,
        })
        throw new DissectedError(responseStatusText, {
            statusCode: responseStatus,
            callerAction: caller,
            errorGroup: DissectedErrorGroups.RESPONSE_NOT_OK,
            statusMessage: responseStatusText,
            verboseMessage: 'response.ok is false',
        })
    }
}
